import React, { useContext, useState } from "react";
import { Button, Input } from "reactstrap";
import Select from "react-select";

import MultiInputFormGroup from "../activities/forms/formgroups/MultiInputFormGroup";
import SingleLineFormGroup from "../activities/forms/formgroups/SingleLineFormGroup";
import VesselableSelector from "../vesselables/VesselableSelector";
import VesselableQuickSelector from "./VesselableQuickSelector";

import { SelectOptions } from "../../contexts/SelectOptions";
import { VesselOptions } from "../../contexts/VesselOptions";
import OptionsDecorator from "../../decorators/OptionsDecorator";
import VesselableDecorator from "../../decorators/VesselableDecorator";

import TooltipLabel from "../utilities/TooltipLabel";


const VesselableFormSection = ({
  onChange,
  reactionProcessVessel,
  previousStepVessel,
  suggestPreviousVessel, // TODO: use or delete. Meant to hide pointless suggestion in Step 1.
  initialSampleVessel,
  suggestInitialVessel,
  typeColor,
  automationMode
}) => {
  const selectOptions = useContext(SelectOptions);
  const vesselables = useContext(VesselOptions);

  const preparationOptions = selectOptions.vessel_preparations;

  const [showVesselTemplates, setShowVesselTemplates] = useState(true)
  const [showVessels, setShowVessels] = useState(false)

  const matchesAutomationMode = (vessel) => !automationMode || vessel.automation_modes?.includes(automationMode)

  const matchesTemplateTpe = (vessel) => {
    return (showVesselTemplates && vessel.vesselable_type === 'VesselTemplate')
      || (showVessels && vessel.vesselable_type === 'Vessel')
  }

  const filteredVesselOptions = vesselables.filter(vessel => {
    return matchesAutomationMode(vessel) && matchesTemplateTpe(vessel)
  })

  const currentVesselable = VesselableDecorator.getVesselableByParams(
    { vesselable_id: reactionProcessVessel?.vesselable_id, vesselable_type: reactionProcessVessel?.vesselable_type },
    vesselables)

  const assignVesselable = (vesselableParams) => {
    onChange(
      {
        ...reactionProcessVessel, // retain id & preparations
        ...vesselableParams
      }
    )
  };

  const handleSelectPreparations = (preparations) => {
    onChange({
      ...reactionProcessVessel,
      preparations: preparations,
    });
  };

  const handleSelectCleanup = (selected) => {
    onChange({
      ...reactionProcessVessel,
      cleanup: selected.value,
    });
  };

  const renderVesselSuggestion = (vesselTemplate, label) => {
    return (
      <div className="pt-1 mb-3">
        <div className="d-flex justify-content-between align-self-center">
          {vesselTemplate ? VesselableDecorator.vesselableSingleLine(vesselTemplate.vesselable)
            : "No " + label + " Vessel assigned"}
          <div className="optional-form-group__open-controls">
            <div className="d-grid gap-2">
              <Button size={'sm'} color={'step'} onClick={() => onChange(vesselTemplate)} disabled={!vesselTemplate}>
                Use {label}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <MultiInputFormGroup label={VesselableDecorator.vesselableType(currentVesselable)} typeColor={typeColor}>
        {!!suggestInitialVessel && renderVesselSuggestion(initialSampleVessel, 'Initial')}
        {!!suggestInitialVessel && renderVesselSuggestion(previousStepVessel, 'Previous')}
        <div className="pt-1 mb-3">
          <div className="d-flex justify-content-between">
            <span className="col-5 col-form-label">
              <Input
                type="checkbox"
                checked={showVesselTemplates}
                onChange={(event) =>
                  setShowVesselTemplates(event.target.checked)
                } /> Vessel-Templates
            </span>
            <span className="col-5 col-form-label">
              <Input
                type="checkbox"
                checked={showVessels}
                onChange={(event) =>
                  setShowVessels(event.target.checked)
                } /> Vessels
            </span>
          </div>
        </div>
        <div className="pt-1 mb-3">
          <VesselableQuickSelector
            currentVesselable={currentVesselable}
            onSelectVesselable={assignVesselable}
            typeColor={typeColor}
            vesselOptions={filteredVesselOptions}
            />
        </div>
        <div className="pt-1 mb-3">
          <VesselableSelector
            currentVesselable={currentVesselable}
            onSelectVesselable={assignVesselable}
            vesselOptions={vesselables}
            typeColor={typeColor}
            buttonLabel={!!reactionProcessVessel?.vesselable_id ? "Change" : "Set"}
            />
        </div>
            {!currentVesselable || matchesAutomationMode(currentVesselable) ||
          <TooltipLabel name={"vessel_unmet_automation_mode"} label={"Vessel unavailable in Automation mode"} />}
        <SingleLineFormGroup label="Preparations:" typeColor={typeColor}>
          <Select
            className="react-select--overwrite"
            classNamePrefix="react-select"
            name="vesselable_preparations"
            isMulti
            isClearable={false}
            options={preparationOptions.preparation_types}
            value={OptionsDecorator.optionsForValues(reactionProcessVessel?.preparations, preparationOptions.preparation_types)}
            onChange={(selected) =>
              handleSelectPreparations(selected.map((option) => option.value))
            }
          />
        </SingleLineFormGroup>
        <SingleLineFormGroup label="Cleanup:" typeColor={typeColor}>
          <Select
            className="react-select--overwrite"
            classNamePrefix="react-select"
            name="vesselable_cleanup"
            options={preparationOptions.cleanup_types}
            value={OptionsDecorator.optionForValue(reactionProcessVessel?.cleanup, preparationOptions.cleanup_types)}
            onChange={handleSelectCleanup}
          />
        </SingleLineFormGroup>
      </MultiInputFormGroup>
    </>
  );
};

export default VesselableFormSection;
